const ReportsIndex = () => import('@/views/Dashboard/Reports/ReportsIndex');
const ReportsGrid = () => import('@/views/Dashboard/Reports/ReportsGrid');
const MembershipTypeReport = () => import('@/views/Dashboard/Reports/MembershipTypeReport');
const MembersCountReport = () => import('@/views/Dashboard/Reports/MembersCountReport');
const CheckInStatisticsReport = () => import('@/views/Dashboard/Reports/CheckInStatisticsReport/CheckInStatisticsReport');
const ExpiredMembershipsReport = () => import('@/views/Dashboard/Reports/ExpiredMembershipsReport');
const InActiveMembersReport = () => import('@/views/Dashboard/Reports/InActiveMembersReport');
const SubscriptionAnniversaryReport = () => import('@/views/Dashboard/Reports/SubscriptionAnniversaryReport');
const BirthdayAnniversaryReport = () => import('@/views/Dashboard/Reports/BirthdayAnniversary/BirthdayAnniversaryReport');
const PurchasesPerVendorReport = () => import('@/views/Dashboard/Reports/PurchasesPerVendor/PurchasesPerVendor');
const OverdueMemberPayment = () => import('@/views/Dashboard/Reports/OverdueMember/OverdueMemberPayment');
const MembersWithOpenBalance = () => import('@/views/Dashboard/Reports/MembersWithOpenBalance/MembersWithOpenBalance');
const ExpiredMembershipEdit = () => import('@/views/Dashboard/Reports/ExpiredMembership/Edit/ExpiredMembershipEdit');
const DailyWorkReport = () => import('@/views/Dashboard/Reports/DailyWorkReport');
const OrganizationPerformance = () => import('@/views/Dashboard/Reports/OrganizationPerformance/OrganizationPerformance');
const InventoryStockReport = () => import('@/views/Dashboard/Reports/InventoryStockReport');
const PaymentLogReport = () => import('@/views/Dashboard/Reports/PaymentLogReport');
const SalesLogReport = () => import('@/views/Dashboard/Reports/SalesLogReport');
const ShiftSummaryReport = () => import('@/views/Dashboard/Reports/ShiftSummaryReport');
const VarianceReport = () => import('@/views/Dashboard/Reports/VarianceReport');
const LabourReport = () => import('@/views/Dashboard/Reports/LabourReport');
const ExceptionReport = () => import('@/views/Dashboard/Reports/ExceptionReport');
const SubscriptionFinancialReport = () => import('@/views/Dashboard/Reports/SubscriptionFinancialReport');
const BranchComparisonReport = () => import('@/views/Dashboard/Reports/BranchComparisonReport');

export default {
  path: '/reports',
  name: 'reports',
  component: ReportsIndex,
  children: [
    {
      path: 'reports-grid',
      name: 'reports-grid',
      component: ReportsGrid,
    },
    {
      path: 'membership-type-report',
      name: 'membership-type-report',
      component: MembershipTypeReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'members/count/report',
      name: 'members-count-report',
      component: MembersCountReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'checkins/count/report',
      name: 'check-in-statistics-report',
      component: CheckInStatisticsReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'expired-memberships-report',
      name: 'expired-memberships-report',
      component: ExpiredMembershipsReport,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'expiredMembershipReportDateFromFilter',
          'expiredMembershipReportDateToFilter',
          'expiredMembershipCertificateStatusFilter',
        ],
      },
    },
    {
      path: 'inactive-members-report',
      name: 'inactive-members-report',
      component: InActiveMembersReport,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'inactiveMembersLastCheckIn',
          'inactiveMembersLastEndDate',
          'inactiveMembersSearch',
        ],
      },
    },
    {
      path: 'purchases-per-vendor-report',
      name: 'purchases-per-vendor-report',
      component: PurchasesPerVendorReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'subscription-anniversary-report',
      name: 'subscription-anniversary-report',
      component: SubscriptionAnniversaryReport,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'subscriptionAnniversarySearch',
        ],
      },
    },
    {
      path: 'birthday-anniversary-report',
      name: 'birthday-anniversary-report',
      component: BirthdayAnniversaryReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'overdue-members-payment',
      name: 'overdue-members-payment',
      component: OverdueMemberPayment,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'overdueMembersPaymentUserId',
        ],
      },
    },
    {
      path: 'members-with-open-balance',
      name: 'members-with-open-balance',
      component: MembersWithOpenBalance,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'overdueMembersPaymentUserId',
        ],
      },
    },
    {
      path: 'daily-work-report',
      name: 'daily-work-report',
      component: DailyWorkReport,
    },
    {
      path: 'organization-performance-report',
      name: 'organization-performance-report',
      component: OrganizationPerformance,
    },
    {
      path: 'branch-comparison-report',
      name: 'branch-comparison-report',
      component: BranchComparisonReport,
    },
    {
      path: 'inventory-stock-report',
      name: 'inventory-stock-report',
      component: InventoryStockReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'payment-log-report',
      name: 'payment-log-report',
      component: PaymentLogReport,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'paymentLogReportDateFromFilter',
          'paymentLogReportDateToFilter',
          'paymentLogReportMethodFilter',
          'paymentLogReportTypeFilter',
        ],
      },
    },
    {
      path: 'sales-log-report',
      name: 'sales-log-report',
      component: SalesLogReport,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'salesLogReportTypeFilter',
        ],
      },
    },
    {
      path: 'shift-summary-report',
      name: 'shift-summary-report',
      component: ShiftSummaryReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'variance-report',
      name: 'variance-report',
      component: VarianceReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'exception-report',
      name: 'exception-report',
      component: ExceptionReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'labour-report',
      name: 'labour-report',
      component: LabourReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'subscription-financial-report',
      name: 'subscription-financial-report',
      component: SubscriptionFinancialReport,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'edit/:id',
      name: 'expired-memberships-edit',
      component: ExpiredMembershipEdit,
      meta: { preservePageStateFor: 'expired-memberships-report' },
    },
  ],
};
